<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="sales_time_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始销售"></el-date-picker>
                    ~
                    <el-date-picker v-model="sales_time_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束销售"></el-date-picker>
                </div>
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="delivery_time_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始预计发货"></el-date-picker>
                    ~
                    <el-date-picker v-model="delivery_time_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束预计发货"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="出库单号"></el-input>
                <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.salesman_id" multiple collapse-tags filterable placeholder="销售人" @visible-change="getSelectList('salesmanUser')">
                    <el-option v-for="list in selectMap.salesmanUser" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select v-if="module.indexOf('warehouse-doc-out-show-customer')!=-1" class="search_select search_inputBox search_inputBox_long" v-model="params.search.customer_id" multiple collapse-tags filterable placeholder="客户" @visible-change="getSelectList('inventoryoutCustomer')">
                    <el-option v-for="list in selectMap.inventoryoutCustomer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.status" placeholder="状态查询">
                    <el-option v-for="list in statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.truck_remark" placeholder="车牌号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.the_type" placeholder="单据类型">
                    <el-option :value="0" label="全部单据"></el-option>
                    <el-option :value="1" label="销售出库单"></el-option>
                    <el-option :value="3" label="采购退货单"></el-option>
                </el-select>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisibleA=!filterDialogVisibleA;scene='inventory.out.list';isGlobal=false;filter=copy_filter;"></div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="inventory.out.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick" @sortTable="sortList"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">件数:{{statistics.count_total}}</div>
                <div class="totalNumber">单据数量:{{statistics.number_total}}</div>
                <div class="totalNumber">出库立方:{{statistics.out_cube_total}}m³</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'出库单('+form_params.order_sn+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="客户名称：" prop="customer_id" v-if="form_params.customer_name!=''&&module.indexOf('warehouse-doc-out-show-customer')!=-1">
                            <!-- <el-select v-model="form_params.customer_id" :disabled="true" filterable>
                                <el-option v-for="list in selectMap.customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.customer_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="销售人：" prop="salesman_id">
                            <!-- <el-select v-model="form_params.salesman_id" :disabled="true" @visible-change="getSelectList('user')">
                                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.salesman_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                         <el-form-item  label="销售日期：" prop="sales_time">
                            <el-date-picker v-model="form_params.sales_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                         <el-form-item  label="出库日期：" prop="out_time">
                            <el-date-picker v-model="out_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <div v-else-if="item.field == 'breed'">
                                                <span style="display: flex;">
                                                    {{ scope.row.breed }}
                                                    <el-tooltip class="item" effect="dark" content="移动端销售调货" placement="top">
                                                        <img v-if="scope.row.is_transfer==1" src="/icon/shunt.png" style="width:17px;height:15px;cursor:pointer;display:block;margin:auto;"/>
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column>
                                <el-table-column label="合同号" width="135" show-overflow-tooltip v-if="billColumn.indexOf(',contract_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.contract_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="供单号" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',original_bale,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_bale }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="货权单位" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',opening_company,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.opening_company }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="库位" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',storage_location,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.storage_location }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="出库状态" width="70" show-overflow-tooltip v-if="billColumn.indexOf(',status_text,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.status_text }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="供应商" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',supplier,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.supplier }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="产地" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',place_origin,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.place_origin }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="属性" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',attribute,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.attribute }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="产品图片" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',thumbnail,')!=-1">
                                    <template slot-scope="scope">
                                        <viewer :images="scope.row.images"> 
                                            <img v-for="(src,index) in scope.row.images" v-show="index < 1" class="viewImg" :src="src" :key="index"/>
                                    </viewer>
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售方数" prop="sales_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="出库方数" prop="out_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',out_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.out_cube }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div class="editLeft" style="border-bottom: 0px solid #ccc;width: 50%;">
                        <textarea class="remarkTextarea" style="border: 1px solid #ccc;" @change="updateTruck_remark" v-model="companyMess.truck_remark" cols="5"></textarea>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="print">打印</el-button>
                        <!-- created by xiong -->
                        <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-doc-out-export,')!=-1" @click="exportExcel">导出</el-button> 
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="form_params.isOrderOut" @click="confirmOutStock">确认出库</el-button>
                    </div>
                </div>
                
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleB" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'采购退货单('+form_params.order_sn+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="供应商名称：" prop="customer_id" v-if="form_params.customer_name!=''&&module.indexOf('warehouse-doc-out-show-customer')!=-1">
                            <!-- <el-select v-model="form_params.customer_id" :disabled="true" filterable>
                                <el-option v-for="list in selectMap.customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.customer_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="退货人：" prop="salesman_id">
                            <!-- <el-select v-model="form_params.salesman_id" :disabled="true" @visible-change="getSelectList('user')">
                                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.salesman_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                         <el-form-item  label="退货日期：" prop="sales_time">
                            <el-date-picker v-model="form_params.sales_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                         <el-form-item  label="出库日期：" prop="out_time">
                            <el-date-picker v-model="out_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div class="editLeft" style="border-bottom: 0px solid #ccc;width: 50%;">
                        <textarea class="remarkTextarea" style="border: 1px solid #ccc;" @change="updateTruck_remark" v-model="companyMess.truck_remark" cols="5"></textarea>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="print">打印</el-button>
                        <!-- created by xiong -->
                        <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-doc-out-export,')!=-1" @click="exportExcel">导出</el-button> 
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="form_params.isOrderOut" @click="confirmOutStock">确认出库</el-button>
                    </div>
                </div>
                
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogReturnVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" title="采购退货单" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <!-- <el-form-item  label="供应商名称：">
                                <el-select  v-model="form_params.supplier_id"  @visible-change="getSelectList('user',$event)">
                                    <el-option v-for="list in selectMap.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item  label="供应商名称：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.supplier" :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <!-- <el-form-item  label="退货人：" class="selectCustomerNoDown">
                                <el-input v-model="form_params.supplier" :disabled="true"></el-input>
                            </el-form-item> -->
                            <el-form-item  label="退货人：" prop="salesman_id">
                                <!-- :disabled="!saleOrderIsEdit" -->
                                <el-select  v-model="form_params.salesman_id"  @visible-change="getSelectList('user',$event)">
                                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item label="退货日期：">
                                <el-date-picker v-model="form_params.contract_time" :disabled="false" type="date" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                    </el-form>
                </el-form>
                <div class="">
                    <div class="editBox">
                        <div class="inwardRoll">
                            <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <!-- <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div> -->
                                            <span >
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                        <!-- <div class="dialogTotal clearfix">
                            <div class="dialogTotalC">合计应退</div>
                            <div class="dialogTotalC" v-if="form_params.rmb_amount&&form_params.rmb_amount!=0.00">退款金额:{{form_params.rmb_amount}}</div>
                            <div class="dialogTotalC" v-if="form_params.tax&&form_params.tax!=0.00">税金:{{form_params.tax}}</div>
                            <div class="dialogTotalC" v-if="form_params.unpay_amount&&form_params.unpay_amount!=0.00">应退金额:{{form_params.unpay_amount}}</div>
                        </div> -->
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;margin-bottom: 10px;">
                        <div class="remarkBox">
                            <textarea class="remarkTextarea" :readonly="false" v-model="form_params.remark" cols="5"></textarea>
                        </div>
                        <!-- v-if="orderType===1||detailInfo.saleOrderIsEdit&&module.includes('order-fee-add')&&!(detailInfo.status==5||detailInfo.status==6||detailInfo.status==7)" -->
                        <!-- <el-button class="funcPublicBtnEdit" style="line-height: 25px;"  @click="openbusinessRelation">关联退货费用</el-button> -->
                        <!-- <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                                <img src="../../assets/top-delete-suspension.png" v-if="!detailInfo.id" class="newFeeImg" @click="delOutFee(index)"/>
                                <img src="../../assets/top-delete-suspension.png" v-else-if="detailInfo.isDeleteFee==1" class="newFeeImg" @click="isDeleteFee(list.id)"/>
                            </div>
                        </div> -->
                        <!-- <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                            </div>
                        </div> -->
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" >确认出库</el-button>
                        
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 单据字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.out.list" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisibleA" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleA = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.out.column" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import bus from "../../eventBus";
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                dialogVisibleWidth:false,
                widthList:[],
                filter:"",
                filters: [],
                filterDialogVisible:false,
                filterDialogVisibleA:false,
                isGlobal:false,
                billColumn:"",
                scene:"",
                copy_filter:"",
                printCustomer:"",
                printSale:"",
                companyName:localStorage.dw_erp_company_name,
                sales_time_start:"",
                sales_time_end:"",
                delivery_time_start:"",
                delivery_time_end:"",
                params:{
                    search:{
                        sales_time_start:"",
                        sales_time_end:"",
                        delivery_time_start:"",
                        delivery_time_end:"",
                        order_sn:"",
                        salesman_id:"",
                        status:999,
                        truck_remark:""
                    },
                    page:1,
                    per_page:50
                },
                listDetail:[
                    {id:"",inventory_id:"",bale_no:"",supplier:"",brand:"",breed:"",pay_status:"",sales_length:"",sales_width_total:"",sales_cube:"",sales_price:""}
                ],
                printDetail:{fields:""},
                printTotal:[],
                form_params:{
                    id:"",
                    account_id:"",
                    first_amount:"",
                    reduce_amoun:"",
                    tax_rate:"",
                    sales_time:"",
                    delivery_time:"",
                    predict_time:"",
                    salesman_id:localStorage.dw_erp_user_id?parseInt(localStorage.dw_erp_user_id):"",
                    customer_id:"",
                    payment_type_id:"",
                    remark:"",
                    is_request_review:"",
                    bank_no:"",
                    account_name:"",
                    out_time:"",
                    bank_name:"",
                    inventory_list:[]
                },
                out_time:new Date(),
                dialogVisible:false,
                dialogVisibleB:false,
                dialogReturnVisible:false,
                last_page:1,
                total:0,
                selectRow:[],
                selectionDetailRow:[],
                selectMap:{
                    salesmanUser:[],
                    customer:[],
                    inventoryoutCustomer:[]
                },
                statusList:[
                    {id:999,name:"全部状态"},
                    {id:1,name:"等待财务审核"},
                    {id:2,name:"等待出库"},
                    {id:3,name:"部分出库"},
                    {id:4,name:"全部出库"}
                ],
                list:[],
                tableCol:[	
                    {colName:"出库单号",colKey:"order_sn",colWidth:170,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"出库状态",colKey:"status_text",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"金融状态",colKey:"redeem_status_text",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,
                    htmlNodeFunc(row) {
                        let color = row['redeem_status'] ==2 ? 'red' : '';
                        if(row['redeem_status'] ==2){
                            return `<span style="color:${color}">${row['redeem_status_text']}</span>`;
                        }else{
                            return `<span>${row['redeem_status_text']}</span>`;
                        }
                    },},
                    {colName:"客户/供应商",colKey:"customer_name",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售日期",colKey:"sales_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"预计发货",colKey:"delivery_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"件数",colKey:"count",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"出库立方",colKey:"sales_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"单据类型",colKey:"sales_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"车牌号",colKey:"truck_remark",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ],
                totalObj:{},
                companyMess:{
                    truck_remark:''
                },
                statistics:{}
            }
        },
        created(){
            // this.getSelectList('user')
            // this.getSelectList("inventoryoutCustomer")
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        mounted(){
            // this.tableCol.forEach(item=>{
            //     if(item.colKey == "customer_name"){
            //         if(this.module.indexOf(",warehouse-doc-out-show-customer,") == -1){
            //             item.isShow = false;
            //         }
            //     }
            // })
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            checkSelectable(row){
                if(row.isSelect==1){
                    return true;
                }else{
                    return false;
                }
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    sales_cube:4,
                    out_cube:4,//出库立方
                },total=>{
                });
            },
            // getBillColumn(){
            //     this.postFunc("/erp/order.fields",{type:1},response=>{
            //         this.billColumn=response.data.data;
            //     },error=>{
            //         this.tip(error.data.message,"warning")
            //     })
            // },
            print(){
                let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + 1;
                window.open(url);
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            //确认出库
            confirmOutStock(){
                this.$confirm('是否确认出库?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = new Object();
                    let arr = new Array();
                    data.order_id=this.form_params.id;
                    this.selectionDetailRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    data.detail_ids=arr.toString();
                    data.out_time = this.formatTimeZero(this.out_time);
                    // this.formatTimeZero(this.out_time);
                    this.postFuncLoading("/erp/inventory.out.confirm",data,()=>{
                        this.dialogVisible=false;
                        this.dialogVisibleB=false;
                        this.tip("出库成功","success");
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            reset(){
                this.sales_time_start="",
                this.sales_time_end="",
                this.delivery_time_start="",
                this.delivery_time_end="",
                this.params={search:{order_sn:"",status:999,customer_id:"",truck_remark:"",sales_time_start:"",sales_time_end:"",delivery_time_start:"",delivery_time_end:"",},page:1,per_page:50}
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.search.sales_time_start = this.formatTimeZero(this.sales_time_start);
                this.params.search.sales_time_end = this.formatTimeZero(this.sales_time_end);
                this.params.search.delivery_time_start = this.formatTimeZero(this.delivery_time_start);
                this.params.search.delivery_time_end = this.formatTimeZero(this.delivery_time_end);
                this.$postColumnList("/erp/inventory.out.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.statistics = res.data.data.count;
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        item.isDelete=false;
                        item.idEdit=false;
                        if(item.sales_time!=0){
                            this.list[index].sales_time = this.formatTime(item.sales_time+"000")
                        }else{
                            this.list[index].sales_time = "";
                        }
                        if(item.delivery_time!=0){
                            this.list[index].delivery_time = this.formatTime(item.delivery_time+"000")
                        }else{
                            this.list[index].delivery_time = "";
                        }
                        if(item.status==5){
                            item.baseColor="green"
                        }else if(item.status==4){
                            item.baseColor="#B400FF"
                        }else{
                            item.baseColor=""
                        }
                    });
                    this.filter = res.data.data.column;
                    this.copy_filter = JSON.parse(JSON.stringify(res.data.data.column))
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                this.scene = 'inventory.out.column';
                this.isGlobal = true;
                this.getBillColumn();
                this.postFunc("/erp/inventory.out.detail",{id:obj.id},res=>{
                    if(obj.row.the_type==3){
                        this.dialogVisibleB=true;
                    }else{
                        this.dialogVisible=true;
                    }
                    this.form_params=res.data.data;
                    this.companyMess.truck_remark = res.data.data.truck_remark;
                    res.data.data.details.forEach(item=>{
                        item.totalPrice=parseFloat(Number(item.sales_cube)*Number(item.sales_price)).toFixed(2)
                    })
                    // this.out_time = res.data.data.out_time == 0 ? new Date() : res.data.data.out_time*1000;
                    this.listDetail=JSON.parse(JSON.stringify(res.data.data.details));
                    this.totalObj=res.data.data.statistic;
                    delete this.form_params.details;
                    delete this.form_params.statistic;
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            if(item.isOrderOut){
                                this.form_params.isOrderOut=true;
                            }
                        }
                    })
                    // if(this.form_params.delivery_time!=0){
                    //     this.form_params.delivery_time = this.formatTime(this.form_params.delivery_time+"000")
                    // }
                    // if(this.form_params.predict_time!=0){
                    //     this.form_params.predict_time = this.formatTime(this.form_params.predict_time+"000")
                    // }
                    this.listDetail.forEach((item,index)=>{
                        this.$nextTick(()=> {
                            if(item.isSelect==1){
                                this.$refs.outBoundDetailTable.toggleRowSelection(this.listDetail[index],true);
                            }
                        })
                    })
                    if(this.form_params.sales_time!=0){
                        this.form_params.sales_time = this.formatTime(this.form_params.sales_time+"000")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                if(row.isSelect==1){
                    this.$refs.outBoundDetailTable.toggleRowSelection(row);
                }else{
                    return false;
                }
            },
            //车牌号备注
            updateTruck_remark(){
                this.postFunc('/erp/order.update.truck',{id:this.form_params.id,truck_remark:this.companyMess.truck_remark},rec=>{
                    this.tip('添加成功',"success")
                    this.getList()
                })
            },
            //导出 created by xiong
            exportExcel(){
                this.$exportExecl("/erp/inventory.out.excel","出库单",{id:this.form_params.id})
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.form_params=this.resetJson(this.form_params);
                    this.form_params.inventory_list=[];
                    this.form_params.salesman_id=localStorage.dw_erp_user_id?parseInt(localStorage.dw_erp_user_id):"";
                    this.out_time = new Date();
                    this.listDetail=[{id:"",inventory_id:"",bale_no:"",supplier:"",brand:"",breed:"",pay_status:"",sales_length:"",sales_width_total:"",sales_cube:"",sales_price:""}]
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
        .editLeft{float: left;}
    }
    // dialog END
</style>
